import { createContext } from 'react';

type Context = {
  isOnline: boolean;
};

export const NetworkStatusContext = createContext<Context>({
  isOnline: false,
});
